import {useState, useRef, useEffect, useCallback} from "react";
import Form, {ButtonItem, GroupItem, RequiredRule, SimpleItem} from "devextreme-react/form";
import {useSnackbar} from "notistack";
import {db} from "../../../../firebase/Firebase";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {FormContainer} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import './settings.css'
import {Button} from "devextreme-react/button";
import VerticalSpace from "../../../../palette/VerticalSpace";
import Alerts from "../../../../palette/Alerts";
import {Filters} from "../../../../utils/HelpFunctions";
import {days} from "../../../../utils/Utils";

const useMountedState = () => {
    const mountedRef = useRef(false)
    const isMounted = useCallback(() => mountedRef.current, [])

    useEffect(() => {
        mountedRef.current = true

        return () => {
            mountedRef.current = false
        }
    }, [])

    return isMounted
}

function RoutesSchedulesFormEdit(props) {

    const {setTrigger, trigger, DataStore, setEdit, dataEdit, setVisibleGrid, dataSource,} = props

    const {companyName, idCompany,} = DataStore

    const [submitButton, setSubmitButton] = useState({
        ...buttonSuccess,
        text: 'Actualizar datos del vehiculo',
        icon: 'far fa-edit'
    })
    const [loading, setLoading] = useState(true)
    const [alert, setAlert] = useState(false)
    const [updateAlert, setUpdateAlert] = useState(false)
    const [hours, setHours] = useState('')
    const [load, setLoad] = useState(false)
    const [newData, setNewData] = useState(null)
    const [success, setSuccess] = useState(false)

    const isMounted = useMountedState()
    const {enqueueSnackbar} = useSnackbar();
    const docRef = db.collection(companyName).doc(idCompany)

    useEffect(() => {
        if (isMounted()) {
            setNewData({...dataEdit})
        }
    }, [dataEdit, isMounted])

    const renderCancelButton = () => {
        return (
            <Button id="cancel-button"
                    icon="fas fa-ban"
                    text="Cancelar"
                    onClick={() => {
                        setEdit(false)
                        setLoad(false)
                        setVisibleGrid(true)
                    }}/>
        )
    }

    const renderAlert = () => {
        return (
            <div>
                {alert && <Alerts severity="warning" body={`Ya se  ha asignado un horario el día ${hours}`}/>}
                <div style={{height: 5}}/>
                {updateAlert && <Alerts severity="warning" body={`No se ha realizado ningún cambio`}/>}
            </div>
        )
    }

    const renderSuccess = () => {
        return (<Alerts severity="success" body={'Ruta actualizada  exitosamente'}/>
        )
    }

    const controlHours = (e) => {

        if (newData && load) {
            const getRoute = Filters(dataSource, 'routeName', newData.routeName)
            const getDays = Filters(getRoute, 'days', newData.days)
            const controlHours = Filters(getDays, 'hour', e.value)

            if (e.value === undefined) {
                const controlHours = Filters(getDays, 'hour', newData.hour)
                const resultAlert = controlHours.length > 0
                setAlert(resultAlert)
                setHours(`${newData.days} a las ${newData.hour}`)
                return
            }

            if (controlHours.length > 0) {
                setAlert(true)
                setHours(`${newData.days} a las ${newData.hour}`)
            } else {
                setAlert(false)
                setUpdateAlert(false)
            }
        } else {
            setLoad(true)
        }
    }

    const updateAll = (key, data, routeName) => {
        setSubmitButton({...submitButton, icon: 'fa fa-spinner fa-spi', disabled: true})
        let count = 0
        const dataResult = Filters(dataSource, 'routeName', routeName)
        dataResult.forEach(async items => {
            const routeId = items.id
            await docRef.collection('Routes').doc(routeId).update({
                [key]: data
            }).then(async () => {
                count = count + 1
                if (count === dataResult.length) {
                    await docRef.collection('Data-Routes').doc(routeName).update({
                        [key]: data
                    }).then(() => {
                        setTrigger(!trigger)
                        setSuccess(true)
                        setTimeout(() => {
                            setEdit(false)
                            setLoading(true)
                            setVisibleGrid(true)
                            setSuccess(false)
                            setLoading(false)
                            setSubmitButton({...submitButton, icon: 'far fa-check-circle', disabled: false})
                            setNewData(null)
                        }, 2000)
                    })
                }
            }).catch(() => {
                setLoading(true)
                setSuccess(false)
                setSubmitButton({...submitButton, icon: 'far fa-check-circle', disabled: false})
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })
        })
    }

    const updateSingle = async (key, data, routeName) => {
        setSubmitButton({...submitButton, icon: 'fa fa-spinner fa-spi', disabled: true})
        const dataResult = Filters(dataSource, 'routeName', routeName)
        const getDays = Filters(dataResult, 'days', newData.days)
        const controlHours = Filters(getDays, 'hour', data)

        if (controlHours.length === 0) {
            setAlert(false)
            const routeId = newData.id

            await docRef.collection('Routes').doc(routeId).update({
                [key]: data
            }).then(() => {
                setTrigger(!trigger)
                setSuccess(true)
                setTimeout(() => {
                    setEdit(false)
                    setLoading(true)
                    setVisibleGrid(true)
                    setSuccess(false)
                    setLoading(false)
                    setSubmitButton({...submitButton, icon: 'far fa-check-circle', disabled: false})
                    setNewData(null)
                }, 2000)
            }).catch(() => {
                setLoading(true)
                setSuccess(false)
                setSubmitButton({...submitButton, icon: 'far fa-check-circle', disabled: false})
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            })

        } else {
            setHours(`${newData.days} a las ${newData.hour}`)
            setSubmitButton({...submitButton, icon: 'far fa-check-circle', disabled: false})
            setAlert(true)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        let flag = false
        if(!alert){
            setLoading(false)
            Object.keys(newData).forEach(async (key) => {
                const items = newData[key]
                if (dataEdit[key] !== items) {
                    flag = true
                    setUpdateAlert(false)
                    if (key === 'rate') {
                        await updateAll(key, items, newData['routeName'])
                    }
                    if (key === 'commissionRate') {
                        await updateAll(key, items, newData['routeName'])
                    }

                    if (key === 'travelTime') {
                        await updateAll(key, items, newData['routeName'])
                    }

                    if (key === 'breakTime') {
                        await updateAll(key, items, newData['routeName'])
                    }

                    if (key === 'days') {
                        await updateSingle(key, items, newData['routeName'])
                    }

                    if (key === 'hour') {
                        await updateSingle(key, items, newData['routeName'])
                    }
                }
            })
            if (!flag) {
                setUpdateAlert(true)
                setAlert(false)
            }
        }

    }

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="routes-schedules-form">
                <HeaderPage icon={'far fa-list-alt'} text={'Actualizar rutas y horarios'} load={loading}
                            textLoad={'Actualizando....'}/>
                <FormContainer>
                    <form action="" onSubmit={handleSubmit}>
                        <Form
                            formData={newData}
                            readOnly={false}
                            showColonAfterLabel={true}
                            validationGroup="edit-schedule"
                        >
                            <GroupItem colCount={1} caption={'Datos'}>
                                <SimpleItem dataField="routeName" label={{text: 'Nombre de la ruta'}}
                                            editorOptions={{disabled: true}}/>
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem dataField="origin" label={{text: 'Origen'}}
                                            editorOptions={{disabled: true}}/>
                                <SimpleItem dataField="destination" label={{text: 'Destino'}}
                                            editorOptions={{disabled: true}}/>

                                <SimpleItem dataField="travelTime" label={{text: 'Tiempo estimado de viaje'}}
                                            editorType="dxNumberBox" editorOptions={{placeholder: 'Minutos'}}>
                                    <RequiredRule message="Ingrese el tiempo de viaje"/>
                                </SimpleItem>

                                <SimpleItem dataField="breakTime" label={{text: 'Tiempo de descanso'}}
                                            editorType="dxNumberBox" editorOptions={{placeholder: 'Minutos'}}>
                                    <RequiredRule message="Ingrese el tiempo de descanso"/>
                                </SimpleItem>

                                <SimpleItem dataField="rate" label={{text: 'Tarifa'}} editorType="dxNumberBox"
                                            editorOptions={{format: "$ #0.##"}}>
                                    <RequiredRule message="Ingrese el tiempo de viaje"/>
                                </SimpleItem>

                                <SimpleItem dataField="commissionRate" label={{text: 'Tarifa de encomienda'}}
                                            editorOptions={{format: "$ #0.##"}} editorType="dxNumberBox">
                                    <RequiredRule message="Ingrese el tiempo de descanso"/>
                                </SimpleItem>
                            </GroupItem>
                            <GroupItem colCount={2}>

                                <SimpleItem dataField="days" label={{text: 'Días'}} editorType="dxSelectBox"
                                            editorOptions={{
                                                items: days,
                                                searchEnabled: true,
                                                placeholder: 'Seleccionar...',
                                                onItemClick: controlHours
                                            }}>
                                    <RequiredRule message="Seleccione el dia"/>
                                </SimpleItem>

                                <SimpleItem dataField="hour" label={{text: 'Hora'}} editorType="dxDateBox"
                                            editorOptions={{
                                                pickerType: 'native',
                                                type: 'time',
                                                placeholder: 'Seleccionar...',
                                                //  value: valueHours,
                                                applyValueMode: 'useButtons',
                                                onValueChanged: controlHours
                                            }}>
                                    <RequiredRule message="Seleccione el dia"/>
                                </SimpleItem>
                            </GroupItem>
                            <GroupItem colCount={1}>
                                <SimpleItem render={renderAlert}/>
                                {success && <SimpleItem render={renderSuccess}/>}
                            </GroupItem>
                            <GroupItem colCount={2}>
                                <SimpleItem render={renderCancelButton}/>
                                <ButtonItem horizontalAlignment="right" buttonOptions={submitButton}/>
                            </GroupItem>
                        </Form>
                    </form>
                </FormContainer>
            </div>
        </>
    )
}

export default RoutesSchedulesFormEdit